const colors = {
    color_black: '#1B1D24',
    color_blue: '#0028FF',
    color_white: '#fff',
    color_white1: '#FBFBFB',
    color_grayDark: '#506473',
    color_gray: '#6C869A',
    color_yellow: '#FFDA50', 
    color_green: '#3efd13',
  }

const fontWeight = {
    font_weightLight: 300,
    font_weightRegular: 400,
    font_weightMedium: 500,
    font_weightSemiBold: 600,
    font_weightBold: 700,
  }


export const theme = { colors, fontWeight }

